import moment from 'moment-timezone';
import removeTruthyProperties from './removeTruthyProperties';
import store from '../store';
import { selectStoreConfig } from '../containers/Layout/selectors';

export const getNotAvailableMenuItems = (menuItemSchedules) => {
  if (!menuItemSchedules?.length) return {};

  const state = store.getState();
  const storeConfig = selectStoreConfig(state);
  const currentOrder = state?.homeReducer?.currentOrder;
  const timeZone = storeConfig?.timeZone || 'Australia/Melbourne';

  const dateTimeToCheck =
    currentOrder?.isFutureDeliveryDate && currentOrder?.deliveryDate
      ? moment.tz(currentOrder.deliveryDate, timeZone)
      : moment.tz(timeZone);

  const schedulesByMenuItem = {};
  menuItemSchedules.forEach((schedule) => {
    const { menuItemId } = schedule;
    if (!menuItemId) return;

    if (!schedulesByMenuItem[menuItemId]) {
      schedulesByMenuItem[menuItemId] = [];
    }
    schedulesByMenuItem[menuItemId].push(schedule);
  });

  let notAvailableMenuItems = {};

  Object.keys(schedulesByMenuItem).forEach((menuItemId) => {
    const itemSchedules = schedulesByMenuItem[menuItemId];
    let isAvailableInAnySchedule = false;

    for (const schedule of itemSchedules) {
      const { days, startTime, endTime } = schedule;

      const checkMoment = dateTimeToCheck;
      const dayOfWeek = checkMoment.isoWeekday();

      const isDayMatch = days?.some((day) => day.day === dayOfWeek);

      if (!isDayMatch) continue;

      const secondsOfDay =
        checkMoment.hours() * 3600 +
        checkMoment.minutes() * 60 +
        checkMoment.seconds();

      const isTimeMatch = secondsOfDay >= startTime && secondsOfDay <= endTime;

      if (isTimeMatch) {
        isAvailableInAnySchedule = true;
        break;
      }

      if (isAvailableInAnySchedule) {
        break;
      }
    }

    if (!isAvailableInAnySchedule) {
      notAvailableMenuItems[menuItemId] = false;
    }
  });

  notAvailableMenuItems = removeTruthyProperties(notAvailableMenuItems);

  return notAvailableMenuItems;
};
